export default "__VITE_ASSET__Cz80LoBP__"